<template>
  <span
    class="dui-toggle-button"
    :class="[
      vm.colorClass,
      {
        'readonly': readonly,
        'toggled': isToggled,
      },
    ]"
    :title="title"
    @click="toggle"
  >
    <span class="toggle" />

    <span
      v-if="!!label"
      class="toggle-label"
    >{{ label }}</span>
  </span>
</template>

<script>
import coloredComponent from '@dui/mixins/colored-component';

export default {
  mixins: [
    coloredComponent,
  ],
  props: {
    label: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isToggled: false,
  }),
  watch: {
    value: function() {
      this.setToggledValue();
    },
  },
  mounted() {
    this.setToggledValue();
  },
  methods: {
    setToggledValue() {
      this.$set(this, 'isToggled', this.value);
    },

    toggle() {
      if (this.readonly) {
        return;
      }

      this.$set(this, 'isToggled', !this.isToggled);
      this.$emit('input', this.isToggled);
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

@mixin makeColorToggle(
  $color: $yellow,
  $variation: base,
  $toggleColor: $white,
  $toggleVariation: base,
  $toggleBackground: getColor($white, base),
) {
  .toggle {
    background-color: $toggleBackground;
    border-color: getColor($color, $variation);

    &:before {
      background-color: getColor($color, $variation);
    }
  }

  &.toggled .toggle {
    background-color: getColor($color, $variation);

    &:before {
      background-color: getColor($toggleColor, $toggleVariation);
    }
  }
}

.dui-toggle-button {
  align-items: center;
  cursor: pointer;
  display: flex;

  &[disabled] {
    opacity: $disabled-opacity;
    pointer-events: none;
  }

  &.readonly {
    pointer-events: none;
  }

  &.inline {
    display: inline-flex;
  }

  .toggle-label,
  .toggle {
    display: inline-block;
    vertical-align: middle;
  }

  .toggle-label {
    font-size: $font-size-base;
    font-weight: normal;
    margin: 0;
    padding-left: $_1em;
  }

  &.font-alt .toggle-label {
    font-family: $alt-font;
    font-size: $font-size-lg;
  }

  .toggle {
    background-color: getColor($white, base);
    border: $border-width-base solid transparent;
    border-radius: $_2em;
    height: $_3em;
    position: relative;
    width: $_5em;

    @include transition((
      background-color,
      border-color
    ));

    &:before {
      border-radius: 50%;
      content: "";
      height: $_2em;
      left: $_0-5em;
      position: absolute;
      top: $_0-5em;
      width: $_2em;

      @include transition((
        background-color,
        transform
      ))
    }
  }

  &.toggled .toggle {
    &:before {
      transform: scale(1.2) translate3d(13px, 0, 0);
    }
  }

  // Color variants
  @include makeColorToggle();
  &.color-yellow { @include makeColorToggle($yellow); }
  &.color-yellow-medium { @include makeColorToggle($yellow, medium); }
  &.color-black { @include makeColorToggle($black); }
  &.color-grey { @include makeColorToggle($grey, dark); }
  &.color-red { @include makeColorToggle($red); }
  &.color-sand { @include makeColorToggle($sand, dark); }
  &.color-white { @include makeColorToggle($white, base, $black, base, transparent); }
  // END Color variants
}

</style>
